"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const AddUser = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "25", height: "25", viewBox: "0 0 25 25", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("g", { clipPath: "url(#a)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#8790A6",
        fillRule: "evenodd",
        d: "M14.094 20.456a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-5 .5h-2v-1h2v-2h1v2h2v1h-2v2h-1v-2Z",
        clipRule: "evenodd"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#8790A6",
        fillRule: "evenodd",
        d: "M13.094 9.956a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm3.493 1a6.557 6.557 0 0 1-3.493.984 6.557 6.557 0 0 1-3.494-.984c-1.412.152-2.506 1.207-2.506 2.487v2.113a5.502 5.502 0 0 1 7.793 3.4h3.921c.158 0 .286-.112.286-.25v-5.263c0-1.28-1.094-2.335-2.507-2.487Z",
        clipRule: "evenodd"
      }
    )),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "a" }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M.094.956h24v24h-24z" })))
  );
};
export default AddUser;
